import React from 'react';
import { Link } from 'react-router-dom';
import { HabbitLogo } from '../HabbitLogo';
export function MarketingFooter() {
  return <footer className="bg-[#050505] border-t border-surface-200/30 pt-16 pb-8" data-id="element-175">
      <div className="max-w-6xl mx-auto px-6" data-id="element-176">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-177">
          <div className="col-span-1 md:col-span-2" data-id="element-178">
            <Link to="/" className="flex items-center gap-3 mb-4" data-id="element-179">
              <HabbitLogo size={30} data-id="element-180" />
              <span className="text-2xl font-mono font-bold tracking-tight text-gray-100" data-id="element-181">
                habbit<span className="text-centurion-500" data-id="element-182">.</span>
              </span>
            </Link>
            <p className="text-gray-400 max-w-sm" data-id="element-183">
              A customizable habit challenge with AI coaching. Pick your habits,
              set your duration, and just show up. Every day.
            </p>
          </div>

          <div data-id="element-184">
            <h4 className="text-gray-100 font-semibold mb-4 uppercase tracking-wider text-sm" data-id="element-185">
              App
            </h4>
            <ul className="space-y-3" data-id="element-186">
              <li data-id="element-187">
                <Link to="/app" className="text-gray-400 hover:text-gray-200 transition-colors text-sm" data-id="element-188">
                  Dashboard
                </Link>
              </li>
              <li data-id="element-189">
                <Link to="/app/calendar" className="text-gray-400 hover:text-gray-200 transition-colors text-sm" data-id="element-190">
                  Calendar
                </Link>
              </li>
              <li data-id="element-191">
                <Link to="/app/analytics" className="text-gray-400 hover:text-gray-200 transition-colors text-sm" data-id="element-192">
                  Analytics
                </Link>
              </li>
              <li data-id="element-193">
                <Link to="/app/settings" className="text-gray-400 hover:text-gray-200 transition-colors text-sm" data-id="element-194">
                  Settings
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-surface-200/30 pt-8 flex flex-col md:flex-row items-center justify-between text-xs text-gray-500" data-id="element-195">
          <p data-id="element-196">
            &copy; {new Date().getFullYear()} habbit.at. All rights reserved.
          </p>
          <p className="mt-2 md:mt-0 font-mono" data-id="element-197">Just show up.</p>
        </div>
      </div>
    </footer>;
}